(function ($) {
	$.fn.topicBar = function () {

		return this.each((i, el) => {
			const $self = $(el);
            const $topicsContainer = $self.find('.topics-container');
			let $topics = $topicsContainer.find('.topic');
            const $lockedTopics = $topicsContainer.find('.topic.locked');
            const $link = $self.find('.link:not(.slider-link)');
            const $sliderLink = $self.find('.link.slider-link');
            let sliderBreakpointSettings = {
                initialized: false,
                set: window.currentBreakpoint()
            }

            const positionLink = () => {
                const $firstLockedTopic = $($lockedTopics[0]);
                const $lastLockedTopic = $($lockedTopics[$lockedTopics.length - 1]);

                if($firstLockedTopic.length && $lastLockedTopic.length){
                    const left = $firstLockedTopic.offset().left;
                    const right = $lastLockedTopic.offset().left + $lastLockedTopic.outerWidth();

                    $link.css('width', right - left);
                    $link.css('left', $firstLockedTopic[0].offsetLeft);
                }
            }

            const positionSliderLink = () => {
                const $visibleLockedTopics = $topicsContainer.find('.topic.locked').filter('[aria-hidden=false]');
                const $firstLockedTopic = $($visibleLockedTopics[0]);
                const $lastLockedTopic = $($visibleLockedTopics[$visibleLockedTopics.length - 1]);

                if($visibleLockedTopics.length < 2) $sliderLink.addClass('x-small');

                if($firstLockedTopic.length && $lastLockedTopic.length){
                    const left = $firstLockedTopic.offset().left;
                    const right = $lastLockedTopic.offset().left + $lastLockedTopic.outerWidth();

                    $sliderLink.css('width', right - left);
                    $sliderLink.css('left', $firstLockedTopic.offset().left - $topicsContainer.offset().left);
                }
            }

            const slidesToShow = () => {
                let result = 5;
                switch(window.currentBreakpoint()){
                    case 'xxl':
                        result = 5;
                    break;
                    case 'xl':
                        result = 5;
                    break;
                    case 'lg':
                        result = 4;
                    break;
                    case 'md':
                        result = 2;
                    break;
                    case 'sm':
                        result = 1;
                    break;
                    case 'xs':
                        result = 1;
                    break;
                }
                return result;
            }

            const linkStyle = () => {
                if($lockedTopics.length < 3) $link.addClass('x-small');
                positionLink();
                $link.css('opacity', 1);
            };

            const sliderLinkStyle = () => {
                $sliderLink.removeClass('x-small');
                if(isMobile()){
                    $sliderLink.removeAttr('style');
                    $sliderLink.css('maxWidth', $self.find('.slick-list').width());
                }else{
                    $sliderLink.removeAttr('style');
                    positionSliderLink();
                }
            };

            const isMobile = () => {
                return ['xs', 'sm', 'md'].includes(window.currentBreakpoint());
            };

            const isSmall = () => {
                return ['xs', 'sm'].includes(window.currentBreakpoint());
            };

            const slidesCount = () => {
                const $slides = isMobile() ? $topicsContainer.find('.topic:not(.slick-cloned):visible, .link') : $topicsContainer.find('.topic:not(.slick-cloned)');
                return $slides.length;
            }

            const resetStyles = () => {
                $sliderLink.appendTo($topicsContainer);
                $lockedTopics.filter(':visible').appendTo($topicsContainer);
                $topics.removeAttr('style');
            }

            const initSlider = () => {
                if(slidesCount() <= slidesToShow()){
                    $self.removeClass('slider-initialized');
                    linkStyle();
                    sliderLinkStyle();
                    return;
                }

                const sliderConfig = {
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: slidesToShow(),
                    slidesToScroll: 1,
                    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""></button>',
                    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""></button>',
                    draggable: false,
                    initialSlide: 0,
                    variableWidth: true,
                    centerMode: isSmall(),
                    swipe: isMobile(),
                    infinite: false,
                    slide: isMobile() ? '.topic:not(.locked), .slider-link' : '.topic',
                };

                $topicsContainer.slick(sliderConfig);

                $topicsContainer.on('afterChange', function(){
                    sliderLinkStyle();
                });

                sliderBreakpointSettings.initialized = true;

                $topics = $topicsContainer.find('.topic');

                const sliderWidth = $self.find('.slick-list').width();
                
                $topics.each((i, el) => {
                    $(el).css('width', sliderWidth / slidesToShow());
                    $(el).css('maxWidth', sliderWidth / slidesToShow());
                });
                
                $self.addClass('slider-initialized');
                $link.removeAttr('style');
                sliderLinkStyle();
            }

            if($link.length){
                linkStyle();
            }

            if($topics.filter(':not(.locked)').length >= 4 ){
                $self.addClass('hide-link');
            }

            $(window).on('resize', function(){
                if(sliderBreakpointSettings.set !== window.currentBreakpoint()){
                    if(sliderBreakpointSettings.initialized) $topicsContainer.slick('unslick');
                    sliderBreakpointSettings.initialized = false;
                    sliderBreakpointSettings.set = window.currentBreakpoint();
                    resetStyles();
                    initSlider();
                }
            });

            if (typeof slick === 'undefined') {
                // variable is undefined
                $(window).on("fr:slickjs-loaded", () => {
                    initSlider();
                });
            }else{
                initSlider();
            }
		});

	}

	$(() => {
		$('.topic-bar-module').topicBar();
	});
})(jQuery);